"use client"

import styled from "@emotion/styled"
import CommonTitle from "../common/bit/CommonTitle"
import { mediaQueries } from "../theme/theme"

export const StyledCommonTitle = styled(CommonTitle, {
  shouldForwardProp: (prop) => prop !== "isSmallerTitle",
})<{ isSmallerTitle?: boolean }>`
  .title {
    ${mediaQueries.tabletDown} {
      font-size: ${({ isSmallerTitle }) => isSmallerTitle && "31px"};
      text-align: center;
    }
    ${mediaQueries.desktopM} {
      font-size: ${({ isSmallerTitle }) => isSmallerTitle && "38px"};
      text-align: ${({ isSmallerTitle }) =>
        isSmallerTitle ? "start" : "center"};
    }
    ${mediaQueries.desktopXl} {
      font-size: ${({ isSmallerTitle }) => isSmallerTitle && "44px"};
    }
  }
`
